import { DashboardIdentity } from './dashboard-identity';

export class DashboardWidgetParams {
  dashboard: DashboardIdentity;
}

export abstract class DashboardChildWidgetParams {
  abstract dashboardChildId: string;
}
